'use client';

import dynamic from 'next/dynamic';
import { Suspense } from 'react';
import { RightSidebarXLContentSkeleton } from './skeleton';
import { useResponsive } from '@wwe-portal/ui/hooks/use-responsive';

const RightSidebarXLContent = dynamic(() =>
  import('./right-sidebar-content').then((module) => ({
    default: module.RightSidebarXLContent,
  }))
);

export const RightSidebar = () => {
  const { xl } = useResponsive();
  if (!xl) return null;
  return (
    <aside className="no-scrollbar bg-back600 z-rightSidebar fixed right-0 top-0 hidden h-screen w-[280px] overflow-auto xl:z-0 xl:block">
      <Suspense fallback={<RightSidebarXLContentSkeleton />}>
        <RightSidebarXLContent />
      </Suspense>
    </aside>
  );
};
